import AsyncSelect from "react-select/async";
import { SearchFieldStyles } from "./SearchFieldStyles";
import servConsultaPrevia from "../../services/login/servConsultaPrevia";

const TipoProjetoSearchField = ({
    field,
    id,
    setOpenError,
    setErrorMessage,
    disabled = false,
    onKeyDown,
    className = ""
}) => {

    const loadTipoProjeto = async (inputValue) => {
        try {

            const response = await servConsultaPrevia.RecuperarTipoProjeto(inputValue);

            let data = response.Content.map(mapResponseToValuesAndLabels);

            return data;

        } catch (err) {
            setOpenError(true);
            setErrorMessage(err.response.data.Message);
        }
    };

    const mapResponseToValuesAndLabels = (data) => {
        return {
            value: data.Id,
            label: data.Nome
        };
    };

    return (
        <AsyncSelect
            id={id}
            cacheOptions
            placeholder="Selecione um tipo de projeto"
            loadOptions={loadTipoProjeto}
            defaultOptions
            isDisabled={disabled}
            styles={SearchFieldStyles}
            {...field}
            onKeyDown={onKeyDown}
            className={className}
        />
    );
};

export { TipoProjetoSearchField };